import { useSyncExternalStore } from 'react';

/**
 * One shared minute tick for relative times ("נכנס לפני 12 דקות"): a single interval while anything is listening,
 * instead of one timer per card.
 */
let now = Date.now();
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | null = null;

function subscribe(cb: () => void) {
  listeners.add(cb);
  if (!timer) {
    now = Date.now();
    timer = setInterval(() => { now = Date.now(); listeners.forEach((l) => l()); }, 60_000);
  }
  return () => {
    listeners.delete(cb);
    if (listeners.size === 0 && timer) { clearInterval(timer); timer = null; }
  };
}

export function useMinuteClock(): number {
  return useSyncExternalStore(subscribe, () => now);
}
